import { formatDate, SHORT_TIME } from "@/utils/dates";
import { ClockIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { usePage } from "@inertiajs/react";
import { FormattedMessage } from "react-intl";

interface OpportunityDetailCardInterface {
    application: boolean;
    logo: string;
    logo_alt: string;
    initials: string;
    has_closed: boolean;
    close_at: string;
    image_src: string;
    alt: string;
    collaborator: {
        hasActiveLicense?: boolean;
        slug?: string;
    };
}

export default function OpportunityDetailCard({
    application,
    logo,
    logo_alt,
    initials,
    has_closed,
    close_at,
    image_src,
    alt,
    collaborator,
}: OpportunityDetailCardInterface) {
    const { realm } = usePage().props;
    return (
        <div
            className={`relative sm:rounded-xl sm:border sm:border-gray-200 overflow-hidden ${
                application ? "" : "sm:h-112"
            }`}
        >
            {collaborator?.hasActiveLicense && (
                <div
                    className={`absolute top-6 left-6 size-16 sm:size-24 border border-gray-200 rounded-lg flex items-center justify-center p-2 ${
                        logo ? "bg-white" : "bg-voice"
                    }`}
                >
                    <a href={`/collaborators/${collaborator.slug}`}>
                        {logo ? (
                            <img src={logo} alt={`Logo for ${logo_alt}`} />
                        ) : (
                            <span className="text-2xl text-white font-semibold">
                                {initials}
                            </span>
                        )}
                    </a>
                </div>
            )}
            {has_closed && (
                <div className="absolute w-full bg-black opacity-90 left-0 bottom-0 sm:rounded-b-xl px-4 py-4">
                    <div className="flex items-center text-white">
                        <span>
                            <XCircleIcon className="size-5" />
                        </span>
                        <span className="text-sm font-semibold ml-2">
                            <FormattedMessage id="This opportunity is closed" />
                        </span>
                    </div>
                </div>
            )}
            <div className="absolute w-full bg-black opacity-90 left-0 bottom-0 sm:rounded-b-xl px-4 py-4">
                <div className="flex items-center text-white">
                    <span>
                        <ClockIcon className="size-5" />
                    </span>
                    <span className="text-sm font-semibold ml-2">
                        <FormattedMessage
                            id="Closes :closeDate"
                            values={{
                                closeDate: formatDate(close_at, realm, {
                                    day: "numeric",
                                    month: "short",
                                    ...SHORT_TIME,
                                }),
                            }}
                        />
                    </span>
                </div>
            </div>

            <img
                src={image_src}
                className="w-full h-full object-cover sm:rounded-b-xl"
                alt={alt}
            />
        </div>
    );
}
